import React from 'react';
import LocationPage from 'pages/dentist/LocationPage';

const LocationDetailsPage: React.FC = () => {
  // Thin wrapper to keep the route name stable; the real screen is LocationPage,
  // which reads `locationId` from history.location.state.
  return <LocationPage/>;
};

export default LocationDetailsPage;


